import React from 'react';
import { Star } from 'lucide-react';
const TestimonialCard = ({
  name,
  location,
  image,
  text,
  stars = 5
}: {
  name: string;
  location: string;
  image: string;
  text: string;
  stars?: number;
}) => <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 flex flex-col h-full" data-id="element-173">
    <div className="flex items-center gap-4 mb-4" data-id="element-174">
      <img src={image} alt={name} className="w-14 h-14 rounded-full object-cover border-2 border-coral-100" data-id="element-175" />
      <div data-id="element-176">
        <h4 className="font-bold text-dark-900" data-id="element-177">{name}</h4>
        <p className="text-xs text-gray-500" data-id="element-178">{location}</p>
        <div className="flex gap-0.5 mt-1" data-id="element-179">
          {[...Array(stars)].map((_, i) => <Star key={i} size={14} className="fill-yellow-400 text-yellow-400" data-id="element-180" />)}
        </div>
      </div>
    </div>
    <p className="text-gray-700 italic flex-grow" data-id="element-181">"{text}"</p>
  </div>;
export function TestimonialsSection() {
  return <section className="py-20 bg-cream-50" data-id="element-182">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-183">
        <div className="text-center mb-16" data-id="element-184">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark-900 mb-4" data-id="element-185">
            Lo que dicen las mujeres que ya lo vivieron
          </h2>
          <div className="w-24 h-1 bg-coral-400 mx-auto rounded-full" data-id="element-186"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-187">
          <TestimonialCard name="María G." location="México" image="https://i.pravatar.cc/150?img=47" text="En solo 10 días noté que mi barriga ya no se hinchaba al final del día. Pensé que era la edad, pero era el cortisol. ¡Ojalá hubiera encontrado esto antes!" data-id="element-188" />
          <TestimonialCard name="Carolina R." location="Colombia" image="https://i.pravatar.cc/150?img=44" text="Llevaba 2 años con fatiga crónica. El protocolo me enseñó a sincronizar mis hábitos y en la segunda semana ya dormía profundo. Mi energía volvió." data-id="element-189" />
          <TestimonialCard name="Valentina M." location="Argentina" image="https://i.pravatar.cc/150?img=49" text="Bajé 4 kilos en 14 días sin hacer cardio. Pero lo mejor fue recuperar la claridad mental. Ya no llego al trabajo agotada." data-id="element-190" />
        </div>
      </div>
    </section>;
}